import * as types from './actionTypes';

function url() {
  return 'api/UserAccount/';
}


export function receiveTokens(ssoToken, exchangeToken) {
  return {
    type: types.USERREG_RECEIVETOKENS, 
    userReg: {
      ssoToken: ssoToken,
      exchangeToken: exchangeToken
   } 
  };
}

export function receiveUserReg(checkOK, data) {
    return {
      type: types.USERREG_LICENSECHECKED, 
      license:   {
        licenseChecked: true,
        validLicense: true, // checkOK - for now bypass license check,
        tenantSignedUp: (data !== undefined ) ? data.userModel.tenantSignedUp : true,
        tenantId: (data !== undefined ) ? data.userModel.tenantId : ''
        }
    };
  }

export function receiveUserRegAPIError(bool, errorMessage) {
    return {
      type: types.USERREG_APIERROR, 
      hasErrored: bool,
      errMsg: errorMessage};
  }

export function checkLicense(licenseToken) {
  let Office = window.Office;

    return (dispatch, getState) => {
      
        console.log('Getting current user...');
        let currentUserEmail = Office.context.mailbox.userProfile.emailAddress;
        
        console.log('Checking license...');
        const state = getState();
        let mrm_exchangeToken ='', mrm_ssoToken= '';
    
        if(state != null) {
           mrm_ssoToken = state.userRegTokens.ssoToken;
           mrm_exchangeToken = state.userRegTokens.exchangeToken;
        }
    
        if(!mrm_exchangeToken) {
          console.log('No exchange token - skip calling license api...');
          return;
        }


        let userRegistrationRequest = {
            ssoToken: mrm_ssoToken,
            exchangeIdentityToken: mrm_exchangeToken,
            licenseToken: encodeURI(licenseToken),
            userEmail: currentUserEmail
        };

        return fetch(url(), {
          method: 'POST',
          mode: 'cors',
          credentials: 'include',
          cache: 'no-store',
          headers: {
            'Accept': 'application/json, text/plain',
            'Content-Type': 'application/json',
            "Authorization": "Bearer " + mrm_ssoToken,
            "X-ExchangeToken": mrm_exchangeToken
          },
          body: JSON.stringify(userRegistrationRequest)
        })
        .then( (response) => {
            if (!response.ok) { return dispatch(receiveUserReg(false)); }
            return response.json();  //we only get here if there is no error
        })
        .then( (data) => dispatch(receiveUserReg(true, data)) )
        .catch( (err) =>  dispatch(receiveUserReg(false)));
      };
}


export const setAccessToken = (token) => ({
    type: "SET_ACCESS_TOKEN",
    payload: token,
});


